<template>
<div class="row blog-masonry">
  <div class="col-md-3 col-xs-12">
    <div class="widget">
      <h6 class="text-uppercase widget-title">About</h6>
      <ul class="icons-list">
        <li v-for="(aboutItem,index) in about" v-bind:key="index">
            {{aboutItem.name}} <span class="pull-right">{{aboutItem.value}}</span>
        </li>
      </ul>
    </div>
    <div class="widget">
      <h6 class="text-uppercase widget-title">Summary</h6>
      <p>{{summary}}</p>
    </div>
    <div class="widget">
      <h6 class="text-uppercase widget-title">Project Goals</h6>
      <div v-if="Array.isArray(goals)">
        <ul class="project-detail-goals" v-for="(goal, index) in goals" v-bind:key="index">
          <li>{{goal}}</li>
        </ul>
      </div>
      <p v-else>{{goals}}</p>
    </div>
  </div>
  <div v-if="image" class="col-md-9 col-xs-12">
    <img :src="image.src" :alt="image.alt"  @load="$emit('image-loaded')"/>
  </div>
</div>
</template>

<script>
export default {
  props: {
    "about": Array,
    "summary": String,
    "goals": {
      "type": String | Array
    },
    "image": Object
  }
}
</script>
<style scoped>
  .widget {
    margin-bottom: 20px;
  }
  .project-detail-goals li {
    list-style-type: square;
    margin-bottom: 10px;
    margin-left: 15px;
  }
</style>